function docReady(fn) {
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

function getPriceFromPrices(prices, options) {
  let p = prices;
  for (let pI = 0; pI < options.length; pI++) {
    if (pI == options.length - 1) {
      return p[options[pI]] || false;
    }
    p = p[options[pI]] || {};
  }
}

function updateOptionPrices(
  product,
  selectOptions,
  radioOptions,
  selectedOptions
) {
  console.log("Update Prices");
  
  const options = [...selectOptions, ...radioOptions];

  if (options.length === 0) {
    return;
  }
  const unavailableText = document.querySelector('[data-unavailable-text]').innerText;
  const prices = {};
  product.variants.forEach((variant) => {
    let subP = prices;
    for (let optionIndex = 0; optionIndex < variant.options.length; optionIndex++) {
      const option = variant.options[optionIndex];
      if (optionIndex == variant.options.length - 1) {
        subP[option] = variant.price;
        break;
      }
      if (!(option in subP)) {
        subP[option] = {};
      }
      subP = subP[option];
    }
  });

  options.forEach(({wrappers}) => {
      wrappers.forEach(wrapper => {
        const priceLabel = wrapper.querySelector('.price')
        if (!priceLabel) {
          return;
        }
        
        const index = wrapper.dataset.variantOptionValueIndex;
        const value = wrapper.dataset.optionValue;

        const checkValues = [...selectedOptions];
        checkValues[index] = value;

        const price = getPriceFromPrices(prices, checkValues);

        if (!price) {
          priceLabel.innerHTML = unavailableText
          return;
        }
        const { moneyFormat } = document.body.dataset;
        const priceStr = Shopify.currencyHelper.formatMoney(price, moneyFormat).trim();

        
        priceLabel.innerHTML = priceStr;
      })   
  })

}

docReady(() => {
  const OptionSelection = customElements.get("options-selection");

  function getSelectedOptions(product, selectOptions, radioOptions) {
    const options = product.options.map(() => "not-selected");
    selectOptions.forEach(({ option }) => {
      if (option.value !== "not-selected") {
        options[parseInt(option.dataset.variantOptionIndex, 10)] = option.value;
      }
    });
    radioOptions.forEach(({ values }) => {
      values.forEach((value) => {
        if (value.checked) {
          options[parseInt(value.dataset.variantOptionValueIndex, 10)] =
            value.value;
        }
      });
    });
    return options;
  }

  OptionSelection.prototype._OriginalUpdateOptions = OptionSelection.prototype._updateOptions;
  OptionSelection.prototype._updateOptions = function (
    disableUnavailableOptions,
    removeUnavailableOptions,
    selectedOptions = null
  ) {
    if (!this._variantSelection) return;
    
    this._OriginalUpdateOptions(
      disableUnavailableOptions,
      removeUnavailableOptions,
      selectedOptions
    );
    
    this._variantSelection
      .getProduct()
      .then((product) => {
        updateOptionPrices(
          product,
          this._selectOptions,
          this._radioOptions,
          selectedOptions ||
            getSelectedOptions(product, this._selectOptions, this._radioOptions)
        );
      });
  };
  console.log("executed");
});
